/* eslint-disable prettier/prettier */
/* eslint-disable */

export enum MaskKeys {
  PHONE_NUMBER = '+7 (999) 999-99-99',
  SNILS = '999-999-999 99'
}
